
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    useCRUDController
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react"

const LibrarySwitchForm = ({
    keyPrefix = "library.backstage.library_switch",
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        LibraryController.getData({})

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
   const LibraryController = useCRUDController({
           apiRoute: "/koha/library"
       })
    useEffect(() => {
        setDataInitialization();
    }, []);


    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                libraryOptions= {LibraryController?.ResponseData}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix = "library.backstage.library_switch",
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    libraryOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'user_id']}
                        fieldKey={[field?.fieldKey, 'user_id']}
                        hidden={true}
                    >
                        <div></div>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'staff_id']}
                        fieldKey={[field?.fieldKey, 'staff_id']}
                        hidden={true}
                    >
                        <div></div>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"分館"}
                        {...field}
                        name={[field?.name ?? '', 'branchcode']}
                        fieldKey={[field?.fieldKey, 'branchcode']}
                        rules={[
                            {
                                required: true,
                                message: "請輸入",
                            },

                        ]}
                    >
                        <Select
                        options={libraryOptions?.map((value)=>{
                            return {
                                label:value?.branchname,
                                value:value?.branchcode
                            }
                        })}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};





export default LibrarySwitchForm;
